import RangePicker from './RangePicker';
import './style/index.less';

export default RangePicker;
